import ThemeOptions from './ThemeOptions';

const themeOptions = { ThemeOptions }
export default themeOptions;
